import React, { useState, useEffect } from 'react'
import { Button, Input, Row, Col, Select, InputNumber, TreeSelect } from 'antd'
import _ from 'lodash'

import Images from '../../Images'

const { Option } = Select;

const initial = {
  equity_governace: [],
  investment_type: [],
  enterprise_value: [],
  equity_investment: [],
  equity_stake: [],
  sectors: [],
  geography: [],
  comment: null,
  status: null
}

const checkData = ['enterprise_value_from', 'enterprise_value_to', 'equity_investment_from', 'equity_investment_to', 'equity_stake_from', 'equity_stake_to'];

function ShareInvestorsFilterPanel(props) {
  const { active, sectors, continents, governance, investmentTypes, choices, initialFilters } = props;

  const [data, setData] = useState(null);
  const [sectorTree, setSectorTree] = useState(null);
  const [continentTree, setcontinentTree] = useState(null);

  const invTypesList = [];
  if (investmentTypes) {
    for (let i = 0; i < investmentTypes.length; i++) {
      invTypesList.push(<Option key={investmentTypes[i].id}>{investmentTypes[i].name}</Option>);
    }
  }

  const statusList = [];
  if (choices && choices.statuses) {
    for (let i = 0; i < choices.statuses.length; i++) {
      statusList.push(<Option key={choices.statuses[i]}>{choices.statuses[i]}</Option>);
    }
  }

  useEffect(() => {
    const newData = initialFilters ? _.cloneDeep(initialFilters) : _.cloneDeep(initial);
    if (initialFilters) {
      newData.enterprise_value = [newData.enterprise_value_from, newData.enterprise_value_to];
      newData.equity_investment = [newData.equity_investment_from, newData.equity_investment_to];
      newData.equity_stake = [newData.equity_stake_from, newData.equity_stake_to];
    }
    applyFilters(newData, true);
    setData(newData);
  }, [0]);

  useEffect(() => {
    if (sectors) {
      const tree = sectors.map(sector => ({
        title: sector.name,
        value: sector.id,
        children: sector.children.map(child => ({
          title: child.name,
          value: child.id,
          children: child.children.map(el => ({
            title: el.name,
            value: el.id,
          }))
        }))
      }));
      setSectorTree(tree);
    }
  }, [sectors]);

  useEffect(() => {
    if (continents) {
      const tree = continents.map(continent => ({
        title: continent.name,
        value: continent.id,
        children: continent.children.map(child => ({
          title: child.name,
          value: child.id,
          children: child.children.map(el => ({
            title: el.name,
            value: el.id,
          }))
        }))
      }));
      setcontinentTree(tree);
    }
  }, [continents]);

  const changeFilter = (field, value, index) => {
    const newData = _.cloneDeep(data);
    if (index != null) {
      newData[field][index] = value;
    } else if (field === 'investment_type') {
      newData[field] = [value];
    } else {
      newData[field] = value;
    }
    setData(newData);
  }

  const clearFilter = (fields, isArray) => {
    const newData = _.cloneDeep(data);
    fields.forEach(field => {
      newData[field] = isArray ? [] : null;
      if (field === 'investment_type') {
        newData.comment = null;
      }
    })
    setData(newData);
    applyFilters(newData);
  }

  const applyFilters = (data, start) => {
    let count = 0;
    if (data) {
      for (let key in _.omit(data, checkData)) {
        if ((!Array.isArray(data[key]) && data[key] != null && key !== 'comment') || (Array.isArray(data[key]) && data[key].length && data[key].some(el => el))) {
          count += 1;
        }
      }
      data.enterprise_value_from = data.enterprise_value[0];
      data.enterprise_value_to = data.enterprise_value[1];
      data.equity_investment_from = data.equity_investment[0];
      data.equity_investment_to = data.equity_investment[1];
      data.equity_stake_from = data.equity_stake[0];
      data.equity_stake_to = data.equity_stake[1];
      data = _.omit(data, ['enterprise_value', 'equity_investment', 'equity_stake']);
    }
    props.changeCount(count, data, start);
  }

  const clearAll = () => {
    setData(_.cloneDeep(initial));
    applyFilters(null);
  }

  const apply = data => {
    applyFilters(data);
    props.closeFilter();
  }

  return (
    <div className="filter-panel" style={{ display: active ? 'block' : 'none' }}>
      {
        data &&
        <>
          <Row gutter={[16, 24]} style={{ marginTop: 0, marginBottom: 0 }}>
            <Col span={12} className="flex-center-vertical">
              <div className="flex-center-vertical filter-title">Sectors</div>
              <TreeSelect
                value={data.sectors}
                showSearch
                multiple
                style={{ minWidth: 'auto', width: '100%' }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                treeData={sectorTree}
                placeholder="Please select"
                treeDefaultExpandAll
                onChange={(value) => changeFilter('sectors', value)}
              />
              <img className="filter-clear" src={Images.closeGrey} alt="" onClick={() => clearFilter(['sectors'], true)} />
            </Col>
            <Col span={12} className="flex-center-vertical">
              <div className="flex-center-vertical filter-title">Geography</div>
              <TreeSelect
                value={data.geography}
                showSearch
                multiple
                style={{ minWidth: 'auto', width: '100%' }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                treeData={continentTree}
                placeholder="Please select"
                treeDefaultExpandAll
                onChange={(value) => changeFilter('geography', value)}
              />
              <img className="filter-clear" src={Images.closeGrey} alt="" onClick={() => clearFilter(['geography'], true)} />
            </Col>

            <Col span={8} className="flex-center-vertical">
              <div className="flex-center-vertical filter-title">EV range</div>
              <Input.Group style={{ width: 'auto', display: 'flex' }}>
                <InputNumber
                  value={data.enterprise_value[0]}
                  style={{ width: '45%', textAlign: 'center' }}
                  placeholder="From"
                  onChange={(value) => changeFilter('enterprise_value', value, 0)}
                />
                <Input
                  className="site-input-split"
                  style={{
                    width: '10%',
                  }}
                  placeholder="~"
                  disabled
                />
                <InputNumber
                  value={data.enterprise_value[1]}
                  className="site-input-right"
                  style={{
                    width: '45%',
                    textAlign: 'center',
                  }}
                  placeholder="To"
                  onChange={(value) => changeFilter('enterprise_value', value, 1)}
                />
              </Input.Group>
              <img className="filter-clear" src={Images.closeGrey} alt="" onClick={() => clearFilter(['enterprise_value'], true)} />
            </Col>
            <Col span={8} className="flex-center-vertical">
              <div className="flex-center-vertical filter-title">Equity range</div>
              <Input.Group style={{ width: 'auto', display: 'flex' }}>
                <InputNumber
                  value={data.equity_investment[0]}
                  style={{ width: '45%', textAlign: 'center' }}
                  placeholder="From"
                  onChange={(value) => changeFilter('equity_investment', value, 0)}
                />
                <Input
                  className="site-input-split"
                  style={{
                    width: '10%',
                  }}
                  placeholder="~"
                  disabled
                />
                <InputNumber
                  value={data.equity_investment[1]}
                  className="site-input-right"
                  style={{
                    width: '45%',
                    textAlign: 'center',
                  }}
                  placeholder="To"
                  onChange={(value) => changeFilter('equity_investment', value, 1)}
                />
              </Input.Group>
              <img className="filter-clear" src={Images.closeGrey} alt="" onClick={() => clearFilter(['equity_investment'], true)} />
            </Col>
            <Col span={8} className="flex-center-vertical">
              <div className="flex-center-vertical filter-title">Equity stake</div>
              <Input.Group style={{ width: 'auto', display: 'flex' }}>
                <InputNumber
                  value={data.equity_stake[0]}
                  style={{ width: '45%', textAlign: 'center' }}
                  placeholder="From"
                  onChange={(value) => changeFilter('equity_stake', value, 0)}
                />
                <Input
                  className="site-input-split"
                  style={{
                    width: '10%',
                  }}
                  placeholder="~"
                  disabled
                />
                <InputNumber
                  value={data.equity_stake[1]}
                  className="site-input-right"
                  style={{
                    width: '45%',
                    textAlign: 'center',
                  }}
                  placeholder="To"
                  onChange={(value) => changeFilter('equity_stake', value, 1)}
                />
              </Input.Group>
              <img className="filter-clear" src={Images.closeGrey} alt="" onClick={() => clearFilter(['equity_stake'], true)} />
            </Col>

            <Col span={8} className="flex-center-vertical">
              <div className="flex-center-vertical filter-title">Status</div>
              <Select
                value={data.status}
                style={{ minWidth: 'auto', width: '100%' }}
                placeholder="Please select"
                onChange={(value) => changeFilter('status', value)}
              >
                {statusList}
              </Select>
              <img className="filter-clear" src={Images.closeGrey} alt="" onClick={() => clearFilter(['status'])} />
            </Col>
            <Col span={8} className="flex-center-vertical">
              <div className="flex-center-vertical filter-title">Governance</div>
              <Select
                value={data.equity_governace}
                mode="multiple"
                style={{ minWidth: 'auto', width: '100%' }}
                placeholder="Please select"
                onChange={(value) => changeFilter('equity_governace', value)}
              >
                {governance?.map(item => {
                  return (
                    <Option key={item.id} value={item.id}>{item.name}</Option>
                  )
                })}
              </Select>
              <img className="filter-clear" src={Images.closeGrey} alt="" onClick={() => clearFilter(['equity_governace'], true)} />
            </Col>
          </Row>

          <Row gutter={[16, 24]} style={{ marginTop: 24, marginBottom: 0 }}>
            <Col span={8} className="flex-center-vertical">
              <div className="flex-center-vertical filter-title">Type of investment</div>
              <Select
                value={data.investment_type[0]}
                style={{ minWidth: 'auto', width: '100%' }}
                placeholder="Please select"
                onChange={(value) => changeFilter('investment_type', value)}
              >
                {invTypesList}
              </Select>
              <img className="filter-clear" src={Images.closeGrey} alt="" onClick={() => clearFilter(['investment_type'], true)} />
            </Col>
            {
              data.investment_type.includes('3') &&
                <Col span={8} className="flex-center-vertical">
                  <Input
                    value={data.comment}
                    placeholder="Please Specify…"
                    onChange={(e) => changeFilter('comment', e.target.value)}
                  />
                  <img className="filter-clear hidden" src={Images.closeGrey} alt="" />
                </Col>
            }
          </Row>
        </>
      }
      <Row gutter={[16, 24]} style={{ marginTop: 24, marginBottom: 0 }} justify="end">
        <div className="filter-actions flex-center-vertical">
          <span className="clear-all" onClick={clearAll}>Reset</span>
          <Button type="primary orange" className="btn-primary" onClick={() => apply(data)}>
            Apply
          </Button>
        </div>
      </Row>
    </div>
  )
}

export default ShareInvestorsFilterPanel
